import BaseTool from "../../baseComponents/BaseTool";
import SliceWidget from "./SliceWidget";
import PointWidget from "./PointWidget";
import ViewWidget from "./ViewWidget";
import ObsWidget from "./ObsWidget";
import cloneDeep from "lodash/cloneDeep";

const PARAM_SCHEMA = {
  plot_widget: {},
  sim_widget: {},
  slice_widget: {},
  point_widget: {},
  view_widget: {},
  obs_widget: {}
}

const DEFAULTS = {
  sim_widget: {
    domain: 'hel',
    variable: 'br',
    time_of_interest: null,
  },
  obs_widget: {
    sc_id: 'omni',
    line_width: 1,
    line_style: 'solid',
    marker_symbol: 'none',
    color: '#E14B00',
  },
  slice_widget: {
    smooth: true,
    rolling_average: 12,
    include_nans: false,
    interpolate_missing_values: false,
    show_sign_only: true,
    show_fill_color: false,
    line_width: 1,
    line_style: 'solid',
    marker_symbol: 'none',
    color: '#004580',
  },
  point_widget: {
    query_point: false,
    point_xvalue: null,
    line_width: 0.8,
    line_style: 'dashed',
    marker_symbol: 'o',
    color: '#A2000B',
    show_point: true,
    show_lines: true,
    show_text: true,
  },
  view_widget: {
    xaxis_min: null,
    xaxis_max: null,
    xaxis_ticks: null,
    yaxis_min: null,
    yaxis_max: null,
    yaxis_ticks: null,
    grid: null,
  },
}

const sharedData = {
  slice_widget: {show_sign_only: null}
}

const flagTriggers = {
  sim_widget: {variable: true}
}


const flagValidators = (widget, k, v, dependencies) => {
  let modifiedParams = cloneDeep(PARAM_SCHEMA);
  modifiedParams.slice_widget.show_sign_only = ["br", "bt", "bp"].includes(v);
  modifiedParams[widget][k] = v;
  return { widget_: "_", params_: modifiedParams };
};

const TimeSeries = ({id, setId}) => {
  return (
    <>
      <BaseTool
        id={id}
        setId={setId}
        tool='time_series'
        toolName='TIME SERIES COMPARISON'
        sharedDeps={sharedData}
        flagTriggers={flagTriggers}
        // flagDeps={flagDependencies}
        flagValidators={flagValidators}
        defaults={DEFAULTS}
        sliceWidget={SliceWidget}
        pointWidget={PointWidget}
        viewWidget={ViewWidget}
        obsWidget={ObsWidget}
      />
    </>

  )
}

export default TimeSeries;